import { ExtendError, getConfiguration, verifyExtend } from "./extend-utils.js";

class ExtendProductOffer extends HTMLElement {
    constructor(productForm, addToCartButton, params) {
        super();
        if (!params) {
            const referenceId = productForm.querySelector('form').id.value;
            const price = meta.product.variants.filter(variant => variant.id == referenceId)[0].price;
            const category = meta.product.type;
            params = {
                referenceId, price, category
            }
        }

        this.params = params;
        this.productForm = productForm;
        this.addToCartButton = addToCartButton; 
        this.config = getConfiguration();
    }
    
    connectedCallback() {
        try {
            this.verifyProductOffer();
        } catch (err) {
            console.error(err.message);
            return;
        }
        
        this.bindEvents();
        
        if (!this.config.pdpOfferEnabled) this.style.display = 'none';
        // Renders Extend offer
        window.Extend.buttons.render(this, this.params);
    }
    
    bindEvents() {
        this.handleAddToCart = this.handleAddToCart.bind(this);
        this.addToCartButton.addEventListener('click', this.handleAddToCart, true);
        
        this.productForm.addEventListener('change', this.handleVariantChange.bind(this), true);

        this.modalDone = this.modalDone.bind(this);
    }
    
    verifyProductOffer() {
        
        let elementsToCheck = [
            'this.productForm',
            'this.addToCartButton',
            'this.params.referenceId',
            'this.params.price',
            'this.params.category'
        ]
        
        let missingElements = elementsToCheck.filter((value) => {
            try {
                return !eval(value);
            } catch (err) {
                return true;
            }
        });
        
        if (missingElements.length) {
            let message = "The following value(s) are null or undefined:\n";
            missingElements.forEach((value) => {
                message += `\t${value}\n`;
            });
            throw new ExtendError(message);
        }
        
        // Checks if Extend lives in the window and the active currency is USD before showing Extend offers
        verifyExtend();
    }
    
    modalDone() {
        // remove default click listener
        this.addToCartButton.removeEventListener('click', this.handleAddToCart, true);
        // click atc button
        // this.addToCartButton.click();
        let productToCart = this.productForm.querySelector('product-to-cart');
        if (productToCart.prop('form-child')) {
            productToCart.loading = true;
            productToCart.addToCart(productToCart.cartItem);
        }
        // add default click listener back
        this.addToCartButton.addEventListener('click', this.handleAddToCart, true);
        
        // If variable set to true, dispatches Extend side cart integration to run after adding to cart via pdp
        if (this.config.dispatchSideCart) window.setTimeout(() => {
            document.dispatchEvent(new Event('extend:plan-add-to-cart'));
        }, 500)
    }
    
    /**
    * Handle add to cart event with offers
    * @param {PointerEvent} e Click event from Add To Cart Button
    */
    handleAddToCart(e) {
         if(window?.BSS_PO && BSS_PO?.appliedOptionSet) {
             let isExistPOevent = e.target?.getAttribute('po-btn-atc') == "true";
        // prevent this action add to cart because optis have been applied and if run this action will conflict with optis app
            if (isExistPOevent) {
                return;
            }
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        const quantityEl = this.productForm.querySelector('[name="quantity"]');
        const quantity = quantityEl && quantityEl.value ? quantityEl.value : 1;
        
        ExtendShopify.handleAddToCart(this, {
            quantity: quantity,
            modal: this.config.modalOfferEnabled,
            done: this.modalDone
        });
    }
    
    handleVariantChange() {
        // Flicker prevention
        this.style.height = `${this.clientHeight}px`;
        
        this.params.referenceId = this.productForm.id.value;
        this.params.price = meta.product.variants.filter(variant => variant.id == this.params.referenceId)[0].price;
        
        
        Extend.setActiveProduct(this, this.params);
    }
}
if (!customElements.get('extend-product-offer'))
    customElements.define('extend-product-offer', ExtendProductOffer);

export function initProductOffer() {
    try {
        if (meta.page.pageType != 'product' || !meta.product)
            throw new ExtendError("Extend Product Offer - The current page is not a product page");
    } catch (err) {
        console.warn(err.message);
        return;
    }

    const productFormSelector = 'product-form[class="#product-form"]';
    const addToCartButtonSelector = 'product-to-cart';

    const productForm = document.querySelector(productFormSelector);
    const addToCartButton = productForm ? productForm.querySelector(addToCartButtonSelector) : document.querySelector(addToCartButtonSelector);
    
    // Create offer and render it
    const extendOffer = new ExtendProductOffer(productForm, addToCartButton);
    productForm.prepend(extendOffer);
}
